// extracted by mini-css-extract-plugin
export default {"container":"a2-z","heading":"b2-z","links":"c2-z","copy":"d2-z","subCopy":"e2-z","linksLeft":"f2-z","linksCenter":"g2-z","linksRight":"h2-z","link":"i2-z","onlyLink":"j2-z"};